import { Message } from '../types'

/**
 * Creates a user message object.
 */
export function createUserMessage(content: string, images?: string[]): Message {
  return {
    id: `user-${Date.now().toString()}`,
    role: 'user',
    content,
    timestamp: new Date(),
    images,
  }
}

/**
 * Creates an assistant message placeholder for streaming.
 */
export function createAssistantMessage(): Message {
  return {
    id: `assistant-${Date.now().toString()}`,
    role: 'assistant',
    content: '',
    timestamp: new Date(),
  }
}

/**
 * Creates an error message for display in the chat.
 */
export function createErrorMessage(error: unknown, assistantMessageId: string): Partial<Message> {
  const errorMessage = error instanceof Error ? error.message : String(error)
  
  return {
    id: assistantMessageId,
    content: `Error: ${errorMessage}\n\nPlease ensure:\n1. OPENAI_API_KEY is set in environment variables\n2. The API key is valid\n3. You have credits in your OpenAI account`
  }
}

/**
 * Prepares messages for the API by converting system messages to assistant messages.
 */
export function prepareMessagesForAPI(messages: Message[]) {
  return messages.map(message => ({
    role: message.role === 'system' ? 'assistant' : message.role,
    content: message.content,
    images: message.images,
  }))
}